export const isObjEmpty = (obj: Record<string, unknown>): boolean => Object.keys(obj).length > 0;
